"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadeClearIconColor = void 0;
var _constants = require("../constants");
var _getShadeBackground = require("./getShadeBackground");
const getShadeClearIconColor = (shade, theme) => _constants.WHITE_COLORS.includes((0, _getShadeBackground.getShadeBackground)(shade, theme)) ? theme.palette.grey[700] : theme.palette.common.white;
exports.getShadeClearIconColor = getShadeClearIconColor;
